import React, { Component, Suspense } from 'react'
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { PrivateRoute } from './components'
import './scss/style.scss'
import { history } from './helpers'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  history.navigate = useNavigate()
  history.location = useLocation()
  return (
    <Suspense fallback={loading}>
      <Routes>
        {/* <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<DefaultLayout />} /> */}

        {/* Privado */}
        <Route element={<PrivateRoute />}>
          <Route path="*" element={<DefaultLayout />} />
          {/* <Route path="users/*" element={<UsersLayout />} /> */}
        </Route>
        {/* Público */}
        <Route path="/login" element={<Login />} />
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
      </Routes>
    </Suspense>
  )
}

export default App
